import { PRICING_CONFIG_URL } from "../../context/paths";

const authHeaders = (token) => ({
    "Content-Type": "application/json",
    "authorization": `Bearer ${token}`,
});

export const getPricingConfig = async (token) => {
    try {
        const response = await fetch(PRICING_CONFIG_URL, {
            method: "GET",
            headers: authHeaders(token),
        });
        return await response.json();
    } catch (error) {
        return { message: "Erro ao obter configuração de preços!", type: "error" };
    }
};

export const publishPricingConfig = async (token, { config, note }) => {
    try {
        const response = await fetch(PRICING_CONFIG_URL, {
            method: "POST",
            headers: authHeaders(token),
            body: JSON.stringify({ config, note }),
        });
        return await response.json();
    } catch (error) {
        return { message: "Erro ao publicar configuração!", type: "error" };
    }
};

export const activatePricingVersion = async (token, version) => {
    try {
        const response = await fetch(`${PRICING_CONFIG_URL}/activate/${version}`, {
            method: "POST",
            headers: authHeaders(token),
        });
        return await response.json();
    } catch (error) {
        return { message: "Erro ao reativar versão!", type: "error" };
    }
};

export const simulatePricing = async (token, { config, case: simCase, cases }) => {
    try {
        const response = await fetch(`${PRICING_CONFIG_URL}/simulate`, {
            method: "POST",
            headers: authHeaders(token),
            body: JSON.stringify(cases ? { config, cases } : { config, case: simCase }),
        });
        return await response.json();
    } catch (error) {
        return { message: "Erro na simulação!", type: "error" };
    }
};
